export default "__VITE_ASSET__DmM2Gfzh__"